// src/store/slices/TermDepositSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ACTIONS } from '../../constants/apiEndpoints';
import { fetchTermDepositAccountsUrl } from '../../services/loandeposits/depositAccount';

export const fetchTermDepositAccounts = createAsyncThunk(
  ACTIONS.fetch_term_deposit_accounts,
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchTermDepositAccountsUrl();
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


const DepositAccountSlice = createSlice({
  name: 'termDepositAccounts',
  initialState: {
  items: [],
  loading: false,
  error: null
},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTermDepositAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTermDepositAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchTermDepositAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export default DepositAccountSlice.reducer;
